// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from '/Users/lk/github/freelogfe-web-repos/packages/www-umi4-3/src/models/__template';
import model_2 from '/Users/lk/github/freelogfe-web-repos/packages/www-umi4-3/src/models/activitiesPage';
import model_3 from '/Users/lk/github/freelogfe-web-repos/packages/www-umi4-3/src/models/activityDetailsPage';
import model_4 from '/Users/lk/github/freelogfe-web-repos/packages/www-umi4-3/src/models/user';

export const models = {
model_1: { namespace: '__template', model: model_1 },
model_2: { namespace: 'activitiesPage', model: model_2 },
model_3: { namespace: 'activityDetailsPage', model: model_3 },
model_4: { namespace: 'user', model: model_4 },
} as const
